import { parseFolders } from './parsers/folders';
export function initFolders() {
  function list() {
    return Promise.resolve(parseFolders());
  }
  return {
    list
  };
}